import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService, AuthenticationService, Config, InitService, isNullOrUndefined } from 'usermgmt';
import { PROJECT_CONSTANTS } from '../../constants/proj.cnst';
import { SideConfig } from '../../models/widget_models';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss']
})

export class SidemenuComponent implements OnInit,OnDestroy {


  @Output() sidebar: EventEmitter<boolean> = new EventEmitter<boolean>
  @Input() toggle: boolean = false;
  panelOpenState = false;
  selectedModule:string = ""
  selectedAdminModule:string = ''
  islogin: boolean = false;
  sideConfig!: SideConfig;
  sideBarData: any;
  isResourceStar: boolean = false;
  private destroy$ = new Subject<void>();
  constructor(
    private authSrv: AuthenticationService,
    private router: Router,
    private initSrv: InitService,
    private appstate: AppStateService,
  ) {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((value: any) => {
      this.onToggleClick(this.router.url);
      this.setSideMenuConfig();
      this.islogin = this.authSrv.isLoggedIn();
    })
  }
  
  ngOnInit(): void {
    this.islogin = this.authSrv.isLoggedIn();
        this.getConfig();
    this.setSideMenuConfig();
    
  }

  getConfig() {
    const sidebarConfig = {
      configType: Config.SIDEBAR_CONFIG
    }
    this.sideConfig = this.initSrv.getConfig(sidebarConfig.configType);    
  }
  
  setSideMenuConfig() {
    this.sideBarData = this.appstate.getUserPermissions();
    if(this.sideBarData[PROJECT_CONSTANTS.APPLICATION_NAME] && 
      this.sideBarData[PROJECT_CONSTANTS.APPLICATION_NAME]['userRoleScope']?.['scope'].length > 0 && 
      this.sideBarData[PROJECT_CONSTANTS.APPLICATION_NAME]['userRoleScope']['scope'][0].scopeValue.length > 0 &&
      this.sideBarData[PROJECT_CONSTANTS.APPLICATION_NAME]['userRoleScope']['scope'][0].scopeValue[0] == '*') {
      this.isResourceStar = true;
    }
  }

    sidebarToogle() {
    this.toggle = !this.toggle;
    this.sidebar.emit(this.toggle);
  }

  naviagateTo(route: any) {
    if(typeof route == 'string') {
      route = JSON.parse(route.replace(/'/g, '"'))
    }
    this.sidebarToogle();
    this.router.navigate(route);
  }

  navigateToPage(route: any) {
    this.sidebarToogle();
    this.router.navigate([route], {
    });
  }
  
  checkForActiveRoute(currentPath : string, routerPath : string) {
    if (!isNullOrUndefined(currentPath) && !isNullOrUndefined(routerPath)) {
      return currentPath.includes(routerPath);
    }
    return false;
  }
  
  onToggleClick(value:any){
    this.selectedModule = (value.split('?'))[0];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
